import { render, staticRenderFns } from "./MatrixByCostCenterReportPageFilters.vue?vue&type=template&id=064a8c67"
import script from "./MatrixByCostCenterReportPageFilters.vue?vue&type=script&lang=js"
export * from "./MatrixByCostCenterReportPageFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports